import {MI} from "../init";

/**
 * @constructor
 * @returns {GameWild}
 */
export default function GameWild() {

    /** @type {GameWildSymbol} */
    this._leftWild;

    /** @type {GameWildSymbol} */
    this._rightWild;

    /** @type {GameMemory} */
    this._memory;

    /** @type {GameConfig} */
    this._config;

    /** @type {SpinReels} */
    this._reels;

    /** @type {SymbolsManager} */
    this._symbolsManager;

    /** @type {Object<string,MadnesAudio>} */
    this.sounds;
}

/**
 * @param {Game} game
 */
GameWild.prototype.create = function(game) {

    this.sounds = game.sounds;
    this._symbolsManager = game.symbolsManager;
    this._config = game.gameCfg;
    this._memory = game.memory;

    this._reels = game.spinReels;

    this._leftWild = new GameWildSymbol();
    this._leftWild.create();

    this._rightWild = new GameWildSymbol();
    this._rightWild.create();
};

GameWild.prototype.resetMemIndex = function() {
    this._getWild(0).memoryId = -1;
    this._getWild(3).memoryId = -1;
};

/**
 * @param {number} reelId
 * @returns {GameWildSymbol|void}
 */
GameWild.prototype._getWild = function(reelId) {

    if(reelId === 0) {
        return this._leftWild;
    }

    if(reelId === 3) {
        return this._rightWild;
    }
};

/**
 * @param {number} type 0 - left, 1 - right
 * @returns {number}
 */
GameWild.prototype._getIndex = function(type) {
    return this._memory.getWildMemory()["index"][type];
};

/**
 * @param {GameMemory} mem
 */
GameWild.prototype.setMemory = function(mem) {
    this._memory = mem;
};

GameWild.prototype.checkWild = function() {
    this._setUnsetWild(0);
    this._setUnsetWild(3);
};

GameWild.prototype._setUnsetWild = function(reelId) {

//	console.warn("_setUnsetWild")

    var wild = this._getWild(reelId);

    if(!wild) {
        return;
    }

    var memId = this._memory.getWildMemoryIndex();

    var leftIdx = this._getIndex(reelId === 0 ? 0 : 1);
    var resSymbols = this._reels.getReel(reelId).getResSymbols();
    var resSymbol = resSymbols[leftIdx];

    if(leftIdx >= 0) {

        if(wild.memoryId !== memId) {

            for(var i = 0; i < resSymbols.length; i++) {
                resSymbols[i].setVisible(true);
            }

            resSymbol.setVisible(false);

            wild.setPos(resSymbol.getPosX(), resSymbol.getPosY());
            wild.setVisible(true);
            wild.reinitScale();
            wild.animLock();

        }

        wild.memoryId = memId;

    } else {

        for(var i = 0; i < resSymbols.length; i++) {
            resSymbols[i].setVisible(true);
        }

        wild.animLockStop();
        wild.setVisible(false);
        wild.memoryId = -1;
    }
};

GameWild.prototype.stopAnimLock = function() {
    this._leftWild.animLockStop();
    this._rightWild.animLockStop();
};

/**
 * @param {number} reelId
 * @returns {undefined}
 */
GameWild.prototype.checkWildResult = function(reelId) {

    var wild = this._getWild(reelId);

    if(!wild) {
        return;
    }

    var symbolIdx = this._getIndex(reelId === 0 ? 0 : 1);

    if(symbolIdx === -1) {
        return;
    }

    wild.memoryId = this._memory.getWildMemoryIndex();

    this.sounds["symbol_joker"].play();

    this._animSet(reelId, wild);
};

/**
 * @param {number} reelId
 * @returns {Promise|undefined}
 */
GameWild.prototype.uncheckWildResult = function(reelId) {

    var wild = this._getWild(reelId);
    if(!wild) {
        return;
    }

    var symbolIdx = this._getIndex(reelId === 0 ? 0 : 1);

    if(symbolIdx > -1) {
        return;
    }

    return new Promise(function(res) {
        wild.animUnset(res);
        wild.memoryId = -1;
    });
};


/**
 * @param {number} reelId
 * @param {GameWildSymbol} wildSymbol
 */
GameWild.prototype._animSet = function(reelId, wildSymbol) {

    var symbolIdx = this._getIndex(reelId === 0 ? 0 : 1);

    var symbol = this._reels.getReel(reelId).getResSymbols()[symbolIdx];

    var x = symbol.getPosX();
    var y = symbol.getPosY();

    wildSymbol.animSet(x, y);

    symbol.setVisible(false);
};

/**
 * @constructor
 * @returns {GameWildSymbol}
 */
function GameWildSymbol() {

    this.set = false;

    /** @type {MadnesObject} */
    this._wildBg;

    /** @type {MadnesObject} */
    this._wild;

    this.memoryId = -1;
}

GameWildSymbol.prototype.create = function() {

    this._wildBg = MI.addImg(-9999, -9999, "wild_bg");
    this._wildBg.setAnchor(0.5, 0.5);
    this._wildBg.setScale(0.6, 0.6);
    this._wildBg.setVisible(false);

    this._wild = MI.addImg(-9999, -9999, "symbols_atlas").setFrameName("symbol_Wild_00000");
    this._wild.setAnchor(0.5, 0.5);
    this._wild.setScale(1.12, 1.12);
    this._wild.setVisible(false);

    var lockFrameNames = MI.generateFrameNames("symbol_Wild_locked_", 0, 34, "", 5);

    this._wildLocked = MI.addImg(-9999, -9999, "wild_locked_atlas");
    this._wildLocked.setAnchor(0.5, 0.5);
    this._wildLocked.setScale(1.12, 1.12);
    this._wildLocked.setVisible(false);
    this._wildLocked.createAnims();
    this._wildLocked.anims.add("lock", lockFrameNames);
    this._wildLocked.anims.addOnComplete(function() {
        this._wildLocked.setVisible(false);
    }.bind(this));
};

/**
 * @param {boolean} visible
 */
GameWildSymbol.prototype.setVisible = function(visible) {
    this._wildBg.setVisible(false);
    this._wild.setVisible(visible);
};

GameWildSymbol.prototype.setPos = function(x, y) {
    this._wildBg.setPos(x, y, true);
    this._wild.setPos(x, y, true);
    this._wildLocked.setPos(x, y, true);
};

GameWildSymbol.prototype.reinitScale = function() {
    this._wild.setScale(1.12, 1.12);
    this._wildLocked.setScale(1.12, 1.12);
};

/**
 * @param {number} x
 * @param {number} y
 * @param {Function=} cb
 */
GameWildSymbol.prototype.animSet = function(x, y, cb) {
    var _self = this;

    if(cb === undefined) { cb = function() {}; }

    this._wildBg.setPos(x, y);
    this._wildBg.setScale(0.6, 0.6);
    this._wildBg.setVisible(true);

    this._wild.setPos(x, y);
    this._wild.setScale(1, 1);
    this._wild.setVisible(true);

    MI.addTween().to(this._wildBg, { 'x': 1.2, 'y': 1.2 }, {
        'scale': true,
        'duration': 250,
        'yoyo': true,
        'callback': function() {
            _self._wildBg.setVisible(false);
        }
    });

    MI.addTween().to(this._wild, { 'x': 1.2, 'y': 1.2 }, {
        'scale': true,
        'duration': 200,
        'callback': function() {
            MI.addTween().to(_self._wild, { 'x': 1.12, 'y': 1.12 }, {
                'scale': true,
                'duration': 150,
                'callback': cb
            });
        }
    });
};

GameWildSymbol.prototype.animUnset = function(cb) {
    var _self = this;

    MI.addTween().to(this._wildBg, { 'x': 0.6, 'y': 0.6 }, {
        'scale': true,
        'duration': 100,
        'callback': function() {
            _self._wildBg.setVisible(false);
        }
    });

    MI.addTween().to(this._wild, { 'x': 1, 'y': 1 }, {
        'scale': true,
        'duration': 100,
        'callback': function() {
            _self._wild.setVisible(false);
            cb && cb();
        }
    });
};

GameWildSymbol.prototype.animLock = function() {

    var x = this._wild.getPosX();
    var y = this._wild.getPosY();

//	var sX = this._wild.getScaleX();
//	var sY = this._wild.getScaleY();

    this._wildLocked.setPos(x, y);
//	this._wildLocked.setScale(sX, sY);

    this._wildLocked.setVisible(true);
    this._wildLocked.anims.stop();

    this._wildLocked.anims.play("lock");
};

GameWildSymbol.prototype.animLockStop = function() {
    this._wildLocked.anims.stop();
    this._wildLocked.setVisible(false);
};